import React from 'react';

import BeaconHowItWorks1 from '../assets/images/beacon_how-it-works-1.svg';
import BeaconHowItWorks2 from '../assets/images/beacon_how-it-works-2.svg';
import BeaconHowItWorks3 from '../assets/images/beacon_how-it-works-3.svg';
import BeaconHowItWorks4 from '../assets/images/beacon_how-it-works-4.svg';
import { HowItWorks } from '../components/home-page/how-it-works';
import { Advantage } from '../components/home-page/advantages';
import { IElementWithVideo } from '../interfaces/IElementWithVideo';
import BeaconLandingHeroVideoWEBM from '../assets/videos/beacon-landing-hero.webm';
import BeaconLandingHeroVideoMP4 from '../assets/videos/beacon-landing-hero.mp4';

export const PARTNER_BEACON_ADVANTAGES: Advantage[] = [
  {
    title: 'Save Time & Money',
    body: 'Gain access to detailed exterior measurements for every facet of any home. Eliminate extra trips to the job site and provide a reliable estimate quickly.',
  },
  {
    title: 'Competitive Edge',
    body: 'Help homeowners discover new material and colors. Show them what their project will look like and gain instant credibility early in the sales process.',
  },
  {
    title: 'Win More Deals',
    body: 'Easily upsell homeowners on additional work or premium products. Beacon 3D+ users typically see an average increase of 5-15% in their close rates.',
  },
];

export const PARTNER_BEACON_HOW_IT_WORKS: HowItWorks = [
  {
    icon: <BeaconHowItWorks1 alt="" style={{ height: 150, width: 150 }} />,
    title: 'Snap a Few Photos',
    body: 'Capture 8 photos using the Beacon 3D+ app. Photos are automatically uploaded to the cloud.',
  },
  {
    icon: <BeaconHowItWorks2 alt="" style={{ height: 150, width: 150 }} />,
    title: 'Create a Quick Quote',
    body: 'Receive all accurate exterior measurements you need to quickly pull together a precise quote.',
  },
  {
    icon: <BeaconHowItWorks3 alt="" style={{ height: 150, width: 150 }} />,
    title: 'Customize the Property',
    body: 'Use Beacon 3D+ design features to change the roof, siding, windows and more on the interactive 3D model.',
  },
  {
    icon: <BeaconHowItWorks4 alt="" style={{ height: 150, width: 150 }} />,
    title: 'Estimate to Order',
    body: '3D+ auto-calculates the exact amount of products you need so you can order seamlessly on Beacon Pro+.',
  },
];

export const PARTNER_BEACON_HERO_VIDEO_SRC: IElementWithVideo['videoSrcs'] = [
  { src: BeaconLandingHeroVideoWEBM, type: 'video/webm' },
  { src: BeaconLandingHeroVideoMP4, type: 'video/mp4' },
];
